import { IStore } from '../../../app/store'
import SetMapCenterCase from "../../usecases/set-map-center/set-map-center.case";
import MapRepository from "../gateways/map.repository";
import LoadCourtsUseCase from "../../usecases/load-courts/load-courts.case";
import CourtsApiGateway from "../gateways/courts-api.gateway";

export default class SearchBarController {
  private readonly store: IStore
  private readonly setMapCenterCase: SetMapCenterCase
  private readonly loadCourtsUseCase: LoadCourtsUseCase

  constructor (store: IStore) {
    this.store = store
    const mapRepo = new MapRepository(store)
    const courtApi = new CourtsApiGateway(store)

    this.setMapCenterCase = new SetMapCenterCase(mapRepo)
    this.loadCourtsUseCase = new LoadCourtsUseCase(courtApi, mapRepo)
  }

  changeLocation (lat: number, lng: number) {
    this.setMapCenterCase.execute(lat, lng)
    this.loadCourtsUseCase.execute()
  }
}
